module.exports = __webpack_public_path__ + "static/media/bank-shield-icon.0932b00d.png";